import isIEorEdge from '../func/isIEorEdge'
import parseSVGPath from '../func/parseSVGPath'
import LinkedList from '../data-structure/LinkedList'
import SimplexNoise from 'simplex-noise'
import Animator from './Animator'
import Renderer from './Renderer'
import parseSvgPathData from '../func/parseSvgPathData'
export default class NSSSVGAnimator {
  constructor () {
    throw new Error('NSSSVGAnimator can not be instanciated')
  }

  static _noise = null
  static _animator = null
  static _renderer = null
  static _isIEorEdge = null
  static createPathDatasFromSVGPath = (path, xoffset, yoffset, scale) => {
    return parseSVGPath(path, xoffset, yoffset, scale)
  }
  static getNoise = () => {
    return (NSSSVGAnimator._noise === null) ? NSSSVGAnimator._noise = new SimplexNoise('test') : NSSSVGAnimator._noise
  }
  static getAnimator = () => {
    return (NSSSVGAnimator._animator === null) ? NSSSVGAnimator._animator = new Animator() : NSSSVGAnimator._animator
  }
  static getRenderer = (type) => {
    return (NSSSVGAnimator._renderer === null) ? NSSSVGAnimator._renderer = new Renderer(type) : NSSSVGAnimator._renderer
  }
  static isIEorEdge = (type) => {
    return (NSSSVGAnimator._isIEorEdge === null) ? NSSSVGAnimator._isIEorEdge = isIEorEdge() : NSSSVGAnimator._isIEorEdge
  }
  static getInnerPointsFromSVGPathDatas = (path, _boundSize, _xPrecision, _yPrecision) => {
    const xPrecision = _xPrecision | 1
    const yPrecision = _yPrecision | 1
    const svgDatas = parseSVGPath(path)
    const pathCanvas = new Path2D(path)
    const canvas = document.createElement('canvas')
    canvas.width = (_boundSize ? 0 : svgDatas.bounds[0]) + svgDatas.bounds[2]
    canvas.height = (_boundSize ? 0 : svgDatas.bounds[1]) + svgDatas.bounds[3]
    const ctx = canvas.getContext('2d')
    if (_boundSize === true) {
      ctx.translate(-svgDatas.bounds[0], -svgDatas.bounds[1])
    }
    if (NSSSVGAnimator.isIEorEdge()) {
      parseSvgPathData(path, parseSvgPathData.canvasIfc, ctx)
      ctx.stroke()
      ctx.fill()
    } else {
      ctx.fill(pathCanvas)
    }
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
    const pixels = imageData.data
    const particles = new LinkedList()
    let pixelIndex
    for (let i = 0; i < canvas.height; i += xPrecision) {
      for (let j = 0; j < canvas.width; j += yPrecision) {
        pixelIndex = (i * canvas.width + j) * 4
        if (pixels[pixelIndex + 3] > 200) {
          particles.append({
            x: 0,
            y: 0,
            sx: j,
            sy: i,
            life: 0,
            velX: 0,
            velY: 0,
            visible: false
          })
        }
      }
    }
    return {particles: particles, bounds: svgDatas.bounds}
  }
}